<script>
  import { format_float_time } from '../../../lib/utils';

  export let order;
  export let role;

  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session';

  let f_duration;
  let f_duration_original;
  let f_price;
  let f_price_original;
  let f_earning;
  let f_earning_original;
  let has_init = false;


  const format_duration = () => {
    if(order.product.based_on !== "product_based_hours"){
      f_duration = `${order.details.duration} ${t9n(order.product.based_on)}`
      f_duration_original = `${order.details.duration_original} ${t9n(order.product.based_on)}`
    } else{
      f_duration = format_float_time(order.details.duration);
      f_duration_original = format_float_time(order.details.duration_original);
    }
    has_init = true;
  }

  const format_price = () => {
    let price = order.product.orderer_price * order.details.duration;
    f_price = `${price.toFixed(2)} ${$session.merchant.currency_sign}`
    
    let price_original = order.product.orderer_price * order.details.duration_original;
    f_price_original = `${price_original.toFixed(2)} ${$session.merchant.currency_sign}`
  }

  const format_earning = () => {
    let earning = order.details.duration * order.product.worker_price;
    f_earning =  `${earning.toFixed(2)} ${$session.merchant.currency_sign}`;

    let earning_original = order.details.duration_original * order.product.worker_price;
    f_earning_original =  `${earning_original.toFixed(2)} ${$session.merchant.currency_sign}`;
  }

  const on_mount = () => {
    format_duration();
    format_price();
    format_earning();
  }

  $: if(!!order && !has_init) on_mount();
</script>


{#if !!order && role === 'orderer'}
  {#if !!order.details}
    {#if !!order.details.duration_original}
      {#if order.status === "order_status_delivered" || order.status === "order_status_not_approved" || order.status === 'order_status_completed' || order.status === "order_status_cancelled_by_orderer" || order.status === "order_status_cancelled_by_worker" || order.status === "order_status_cancelled_by_admin"}
        <div class="mdc-card detail-section" style='background-color: #FFCECE'>
        <div class="mdc-data-table" style='background-color: #FFCECE !important;'>


          {#if order.status === "order_status_delivered"}
            <span style='display: flex;'>
              <h3 style='margin-left: 8px'>{t9n(TS.ORDER_DETAILS_DURATION_WARNING_LABEL)}</h3>
               <i class="material-icons mdc-text-field__icon">error</i>
            </span>
            <p style='margin-left: 10px; margin-top: -5px; '>
              {t9n(TS.ORDER_DETAILS_DURATION_WARNING_INFO)}
            </p>
          {:else}
            {#if order.status === "order_status_not_approved"}
              <p style='margin-left: 12px'>{t9n(TS.ORDER_DETAILS_DURATION_ORDERER_NOT_APPR)}</p>
            {:else}
              <p style='margin-left: 12px'>{t9n(TS.ORDER_DETAILS_DURATION_ORDERER_APPR)}</p>
            {/if}

          {/if}

          <table class="mdc-data-table__table">
            <tbody class="mdc-data-table__content">
            <tr class="mdc-data-table__row">

              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_ORIGINAL)}</th>


              <td class="mdc-data-table__cell cell-right">
                {f_duration_original}
              </td>
            </tr>
            <tr class="mdc-data-table__row">
              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_ORIGINAL_PRICE)}</th>

              <td class="mdc-data-table__cell cell-right">
                {f_price_original}
              </td>
            </tr>
            <tr class="mdc-data-table__row">
              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_CURRENT)}</th>

              <td class="mdc-data-table__cell cell-right">
                {f_duration}
              </td>
            </tr>

            <tr class="mdc-data-table__row">
              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_CURRENT_PRICE)}</th>

              <td class="mdc-data-table__cell cell-right">
                {f_price}
              </td>
            </tr>
            {#if !!order.details.duration_change_explanation}
              <tr class="mdc-data-table__row">
                <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_REASON)}</th>

                <td class="mdc-data-table__cell cell-right">
                  {order.details.duration_change_explanation}
                </td>
              </tr>
            {/if}

            </tbody>
          </table>
        </div>
        </div>
      {/if}
    {/if}
  {/if}
{/if}

<!--{#if !!order && role === 'orderer'}-->
<!--  {#if !!order.details}-->
<!--    {#if !!order.details.duration_original}-->
<!--      {}-->
<!--        <div class="mdc-card detail-section" style='background-color: #FFCECE'>-->
<!--          <p style='margin-left: 12px'>{t9n(TS.ORDER_DETAILS_DURATION_ORDERER_APPR)}</p>-->
<!--        </div>-->
<!--      {/if}-->
<!--    {/if}-->
<!--  {/if}-->
<!--{/if}-->


{#if !!order && role === 'worker'}
  {#if !!order.details}
    {#if !!order.details.duration_original}
      {#if order.status === "order_status_not_approved" || order.status === 'order_status_completed' || order.status === "order_status_cancelled_by_orderer" || order.status === "order_status_cancelled_by_worker" || order.status === "order_status_cancelled_by_admin"|| order.status === "order_status_delivered"}
        <div class="mdc-card detail-section" style='background-color: #FFCECE'>
        <div class="mdc-data-table" style='background-color: #FFCECE !important; padding-top: 10px;'>
          <p style='margin-left: 10px; margin-top: -5px; '>
            {t9n(TS.ORDER_DETAILS_DURATION_WORKER)}
          </p>

          <table class="mdc-data-table__table">
            <tbody class="mdc-data-table__content">
            <tr class="mdc-data-table__row">
              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_ORIGINAL)}</th>

              <td class="mdc-data-table__cell cell-right">
                {f_duration_original}
              </td>
            </tr>
            {#if order.status === "order_status_delivered"}
              <tr class="mdc-data-table__row">
                <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_ORIGINAL_AMOUNT)}</th>

                <td class="mdc-data-table__cell cell-right">
                  {f_earning_original}
                </td>
              </tr>
            {/if}
            <tr class="mdc-data-table__row">
              <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_CURRENT)}</th>

              <td class="mdc-data-table__cell cell-right">
                {f_duration}
              </td>
            </tr>
            {#if order.status === "order_status_delivered"}
              <tr class="mdc-data-table__row">
                <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_UPDATED_AMOUNT)}</th>

                <td class="mdc-data-table__cell cell-right">
                  {f_earning}
                </td>
              </tr>
            {/if}
            {#if !!order.details.duration_change_explanation}
              <tr class="mdc-data-table__row">
                <th class="mdc-data-table__cell">{t9n(TS.ORDER_DETAILS_DURATION_WARNING_REASON)}</th>

                <td class="mdc-data-table__cell cell-right">
                  {order.details.duration_change_explanation}
                </td>
              </tr>
            {/if}

            </tbody>
          </table>
        </div>
        </div>
      {/if}
    {/if}
  {/if}
{/if}

<style>
    .detail-section {
        margin-top: 8px;
        padding: 24px;
        color: #616161;
    }
    h3{
        margin-top: 3px;
    }
    .material-icons{
        position: absolute;
        right: 0;
    }
    .mdc-data-table__cell {
        color: #616161;

        /*background-color: #fafafa;*/
    }

    .cell-right {
        max-width: 200px;
        word-wrap: break-word;
        white-space: normal;
    }

    .mdc-data-table {

        width: 100%;
        border: 0;
        border-radius: 0;
        overflow-x: auto;
        position: relative;
        /*border-style: 0;*/
    }

    .mdc-data-table__row {
        /*border-top-width: 1px;*/
        border-top-style: dashed;
    }

    th {
        font-weight: 800;
        text-align: left;
        max-width: 300px;
        min-width: 150px;
        /*word-wrap: break-word;*/
        /*white-space: normal;*/
    }

    td {
        width: 100%;
        font-weight: 500;
    }
</style>